<form autocomplete="off" [formGroup]="form" >
  <div class="row">
    <div class="col-12">
      <div class="card mb-3 bg-2">
        <div class="card-body pb-2">
          <div class="row mt-2 d-flex">
            <div class="col-sm-12 col-md-6">
              <carteira-autocomplete #carteiraAutocomplete [schema]="carteiraSchema"></carteira-autocomplete>
            </div>
            <div class="col-sm-12 col-md-6">
              <lib-autocomplete #regraAutocomplete [schema]="regraSchema"></lib-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2 mr-8">
              <mat-form-field class="medium-input" appearance="outline">
                <mat-label>Execução</mat-label>
                <mat-select formControlName="tipoExecucao" [compareWith]="compareFunctionObjects">
                  <mat-option [value]="null"></mat-option>
                  <mat-option *ngFor="let tipo of tiposExecucao" [value]="tipo">{{tipo.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4"></div>
            <div class="col-3">
              <lib-datepicker-day [schema]="dataInicioSchema"></lib-datepicker-day>
            </div>
            <div class="col-sm-4 col-md-3 col-xl-2">
              <lib-datepicker-day [schema]="dataFimSchema"></lib-datepicker-day>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="d-flex flex-end justify-content-end">
            <div class="pr-3">
              <button
                      mat-raised-button
                      color="primary"
                      [disabled]="form.invalid || (loading$ | async)" label="Pesquisar"
                      type="submit"
                      (click)="totalRegistros = 0; page$.next(1); pesquisar(this.form)"
                      title="Pesquisar"
                      aria-label="left">
                <loading-icon [btnLabel]="'Pesquisar'" [loading]="loading$ | async"></loading-icon>
              </button>
            </div>
            <div>
                <button mat-raised-button
                        [matMenuTriggerFor]="menuExportarAssociacao"
                        [disabled]="(loadingExport$ | async) || !showExecutar">
                  <loading-icon
                    [btnLabel]="'Exportar'"
                    [loading]="loadingExport$ | async"
                  ></loading-icon> <span class="caret"></span>
                </button>
                <mat-menu #menuExportarAssociacao="matMenu">
                  <button mat-menu-item (click)="exportarPdf()">
                    <span>PDF</span>
                  </button>
                  <button mat-menu-item (click)="exportarXls()">
                    <span>Excel</span>
                  </button>
                </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<app-total-table (onChange)="onChangeTotalPagina($event)" [totalRegistros]="this.totalRegistros" ></app-total-table>
<table class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
  <thead>
  <tr>
    <th>Carteira</th>
    <th>Regra</th>
    <th>Execução on-line</th>
    <th>Data início associação</th>
    <th>Data fim associação</th>
    <th class="text-center">Ações</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let a of associacoes">
    <td>{{a.carteira}}</td>
    <td>{{a.regra}}</td>

    <td *ngIf="!associacaoIsEqual(associacaoEdicao, a)">{{getTipoExecucao(a.processamentoOnlineAtivo)}}</td>
    <td *ngIf="associacaoIsEqual(associacaoEdicao, a)">
      <mat-slide-toggle [color]="'primary'" [(ngModel)]="associacaoEdicao.processamentoOnlineAtivo"> On-line</mat-slide-toggle>
    </td>

    <td *ngIf="!associacaoIsEqual(associacaoEdicao, a)">{{a.inicio}}</td>
    <td *ngIf="associacaoIsEqual(associacaoEdicao, a)">
      <mat-form-field style="width: 90px;">
        <input matInput libMask="00/00/0000" [(ngModel)]="associacaoEdicao.inicio"/>
      </mat-form-field>
    </td>

    <td *ngIf="!associacaoIsEqual(associacaoEdicao, a)">{{a.fim}}</td>
    <td *ngIf="associacaoIsEqual(associacaoEdicao, a)">
      <mat-form-field style="width: 90px;">
        <input matInput libMask="00/00/0000" [(ngModel)]="associacaoEdicao.fim"/>
      </mat-form-field>
    </td>

    <td class="pt-1 pb-1" *ngIf="!associacaoIsEqual(associacaoEdicao, a)">
      <div class="d-flex flex-row justify-content-center">
        <div class="pr-2">
          <button mat-icon-button type="button" (click)="setModoEdicao(a)" title="Editar">
            <i class="fas fa-edit" aria-hidden="true"></i>
          </button>
        </div>
        <div>
          <button mat-icon-button color="warn" type="button" (click)="openDeleteDialog(a)" title="Excluir" data-toggle="modal"
                  data-target="#confirm-dialog-modal">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </td>

    <td class="pt-1 pb-1" *ngIf="associacaoIsEqual(associacaoEdicao, a)">
      <div class="d-flex flex-row justify-content-center">
        <div class="pr-2">
          <button mat-icon-button type="button" (click)="save()" title="Salvar">
            <i class="fas fa-save" aria-hidden="true"></i>
          </button>
        </div>
        <div>
          <button mat-icon-button type="button" (click)="setModoEdicao(null)" title="Cancelar">
            <i class="fas fa-undo" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div class="d-flex justify-content-center mb-5">
  <maps-pagination [items]="paginationTotalPage" [pageNumber]="page$" *ngIf="paginationTotalPage && paginationTotalPage > 0"
                   (pageSend)="receiverPage($event)"></maps-pagination>
</div>
